import React, { useEffect } from 'react';
import { bool, func } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { path, pathOr } from 'ramda';

import { ensureCurrentUser } from '../../../../util/data';
import { propTypes } from '../../../../util/types';
import { manageDisableScrolling } from '../../../../ducks/UI.duck';
import { sendVerificationEmail } from '../../../../ducks/user.duck';
import {
  savePersonalInfos,
  changeEmailClear,
  updateProfile,
} from '../../../../ducks/userSettings.duck';
import { PersonalInfosForm } from '../../../../forms';

import css from './PersonalInfosTab.module.css';
import { getMarketplaceEntities } from '../../../../ducks/marketplaceData.duck';
import { queryUserListings } from '../../../ProfilePage/ProfilePage.duck';
import { isNilOrEmpty } from '../../../../util/validators';

const PersonalInfosTab = (props) => {
  const {
    changeEmailError,
    changeEmailInProgress,
    currentUser,
    onChange,
    onResendVerificationEmail,
    onSubmitPersonalInfos,
    onUpdateProfile,
    onQueryUserListings,
    personalInfosChanged,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    updateInProgress,
    updateProfileError,
    onManageDisableScrolling,
    hasListings,
  } = props;
  const user = ensureCurrentUser(currentUser);
  const userId = pathOr(null, ['id', 'uuid'], user);
  useEffect(() => {
    if (!userId) return;

    onQueryUserListings(userId);
  }, [userId]);
  const currentEmail = pathOr('', ['attributes', 'email'], user);
  const { firstName, lastName, protectedData, privateData } = pathOr(
    {},
    ['attributes', 'profile'],
    user
  );
  const birthdayDate = pathOr('', ['birthdayDate'], protectedData);
  const birthPlace = pathOr('', ['birthPlace'], protectedData);
  const currentPhoneNumber = pathOr('', ['phoneNumber'], protectedData);
  const currentBirthdayDate = pathOr('', ['birthdayDate'], protectedData);
  const currentLanguage = pathOr('', ['language'], privateData);
  const taxIdNumber = pathOr('', ['taxIdNumber'], privateData);
  const hasNoTaxIdNumber = pathOr(false, ['hasNoTaxIdNumber'], privateData);
  const howDidYouKnowUs = path(['howDidYouKnowUs'], protectedData);
  const handleSaveTaxIdNumber = ({ taxIdNumber, hasNoTaxIdNumber }) => {
    onUpdateProfile({
      privateData: {
        taxIdNumber: hasNoTaxIdNumber ? null : taxIdNumber || null,
        hasNoTaxIdNumber: !!hasNoTaxIdNumber,
      },
    });
  };
  const handleSubmit = ({ taxIdNumber, hasNoTaxIdNumber, ...values }) => {
    const formattedValues = {
      ...values,
      currentFirstName: firstName,
      currentLastName: lastName,
      currentBirthdayDate,
      currentEmail,
      currentPhoneNumber,
      currentLanguage,
    };
    if (hasListings) {
      handleSaveTaxIdNumber({ taxIdNumber, hasNoTaxIdNumber });
    }
    onSubmitPersonalInfos(formattedValues);
  };
  const initialValues = {
    firstName,
    lastName,
    email: currentEmail,
    phoneNumber: currentPhoneNumber,
    birthdayDate,
    birthPlace,
    language: currentLanguage,
    howDidYouKnowUs,
    taxIdNumber,
    hasNoTaxIdNumber,
  };

  return (
    <PersonalInfosForm
      className={css.form}
      changeEmailError={changeEmailError}
      changeEmailInProgress={changeEmailInProgress}
      formId="PersonalInfosForm"
      onManageDisableScrolling={onManageDisableScrolling}
      onResendVerificationEmail={onResendVerificationEmail}
      sendVerificationEmailError={sendVerificationEmailError}
      sendVerificationEmailInProgress={sendVerificationEmailInProgress}
      updateInProgress={updateInProgress}
      updateProfileError={updateProfileError}
      initialValues={initialValues}
      onChange={onChange}
      onSubmit={handleSubmit}
      ready={personalInfosChanged}
      hasListings={hasListings}
    />
  );
};

PersonalInfosTab.defaultProps = {
  changeEmailError: null,
  currentUser: null,
  sendVerificationEmailError: null,
};

PersonalInfosTab.propTypes = {
  changeEmailError: propTypes.error,
  changeEmailInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  onChange: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onSubmitPersonalInfos: func.isRequired,
  onResendVerificationEmail: func.isRequired,
  personalInfosChanged: bool.isRequired,
  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  updateInProgress: bool.isRequired,
  updateProfileError: propTypes.error,
};

const mapStateToProps = (state) => {
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
  const {
    changeEmailError,
    changeEmailInProgress,
    personalInfosChanged,
    updateInProgress,
    updateProfileError,
  } = state.userSettings;
  const hasListings = !isNilOrEmpty(pathOr({}, ['entities', 'ownListing'], state.marketplaceData));

  return {
    hasListings,
    changeEmailError,
    changeEmailInProgress,
    currentUser,
    personalInfosChanged,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    updateInProgress,
    updateProfileError,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChange: () => dispatch(changeEmailClear()),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onSubmitPersonalInfos: (values) => dispatch(savePersonalInfos(values)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onUpdateProfile: (data) => dispatch(updateProfile(data)),
  onQueryUserListings: (userId) => dispatch(queryUserListings(userId)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(PersonalInfosTab);
